import React from 'react';
import ReactDOM from 'react-dom';
import ContactCard from './ContactCard';
import LoadingContainer from './LoadingContainer';
import NetworkStatus from './NetworkStatus';
import Navigation from './Navigation';
import ContactMessage from './ContactMessage';
import Notifications from './Notifications';
import AuthError from './AuthError';

export default class ContactsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, contacts: [], authError: window.authError };
    this.fetchContacts = this.fetchContacts.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.onRejectCall = this.onRejectCall.bind(this);
  }

  componentWillMount() {
    window.ContactsList = this;
    if (this.props.socket.connected) {
      this.fetchContacts();
    } else {
      this.props.socket.once('connect', () => {
        this.fetchContacts();
      });
    }
    this.props.socket.on('reconnect', this.fetchContacts);
    this.props.socket.on('change-status', this.onChangeStatus);
    this.props.socket.on('reject-call', this.onRejectCall);
  }

  componentWillUnmount() {
    delete window.ContactsList;
    this.props.socket.removeListener('reconnect', this.fetchContacts);
    this.props.socket.removeListener('change-status', this.onChangeStatus);
    this.props.socket.removeListener('reject-call', this.onRejectCall);
  }

  onChangeStatus(msg) {
    console.log('User Status Changed', msg);
    const contacts = this.state.contacts.slice();
    const contact = contacts.find(c => c.email === msg.email);
    if (contact) {
      contact.status = msg.status;
      this.setState({ contacts });
    }
  }

  async onRejectCall(msg) {
    console.log('Reject Call', msg);
    ReactDOM.unmountComponentAtNode(document.getElementById('makingCall'));
    ReactDOM.render(
      <ContactMessage
        socket={this.props.socket}
        name={msg.name}
        msgKey="userBusy"
      />,
      document.getElementById('contactMessage'));
  }

  fetchContacts() {
    this.props.socket.emit('get-contacts', null, (contacts) => {
      console.log('Contacts Received', contacts);
      this.setState({ loading: false, contacts });
    });
  }

  showAuthError() {
    this.setState({ authError: true });
  }

  hideAuthError() {
    this.setState({ authError: false });
  }

  renderContacts() {
    const locale = global.dictionaries.calling;
    if (this.state.loading) {
      return (
        <LoadingContainer />
      );
    }
    if (Array.isArray(this.state.contacts) && this.state.contacts.length > 0) {
      return (
        <div className="columns is-multiline">
          {
            this.state.contacts.map(contact => (
              <div key={contact.email} className="column is-4 has-text-centered">
                <ContactCard
                  socket={this.props.socket}
                  name={contact.name}
                  email={contact.email}
                  picture={contact.picture}
                  status={contact.status}
                />
              </div>))
          }
        </div>
      );
    } else {
      return (
        <div className="columns is-centered">
          <article className="message is-warning">
            <div className="message-header">
              <p>{locale.noContactsTitle}</p>
            </div>
            <div className="message-body">
              {locale.noContactsContents}
            </div>
          </article>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="module-calling">
        <NetworkStatus />
        <Navigation socket={this.props.socket} />
        <div id="makingCall" />
        <div id="contactMessage" />
        {this.state.authError ?
          <AuthError /> :
          <div className="columns is-centered">
            <div className="column is-8">
              <div className="section">
                {this.renderContacts()}
              </div>
            </div>
            <Notifications />
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactsList.js